var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a15e4a22-fa0c-49de-8e1c-93a3b2b52c8f",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vbl") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.66,104a5.88,5.88,0,0,1-5.36-3.44L30.08,47.23a5.8,5.8,0,0,1-.15-4.48A5.89,5.89,0,0,1,33,39.46l33-15a5.88,5.88,0,0,1,7.77,2.92L98,80.9a5.91,5.91,0,0,1-3,7.64l-33,15A5.7,5.7,0,0,1,59.66,104Zm8.7-77a2.69,2.69,0,0,0-1.16.25l-33,15A2.87,2.87,0,0,0,32.81,46L57,99.34a2.93,2.93,0,0,0,3.79,1.43l33-15a2.87,2.87,0,0,0,1.45-3.72L95,81.61,71,28.66A2.9,2.9,0,0,0,68.36,27Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.2f85ec9f31c7cb5b89a3a3316b092a51.svg";
export { ForwardRef as ReactComponent };